import React from 'react';
import PropTypes from 'prop-types';
import { string } from 'yup';
import BaseInput from '../base';

const Zip = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <BaseInput
      name="zip"
      label="Zip Code"
      type="text"
      autoComplete="off"
      transparent
      maxLength="5"
      validate={val =>
        string()
          .required('Enter a zip code')
          .matches(/^\d{5}$/, {
            message: 'Enter a valid zip'
          })
          .max(5, 'Zip cannot be greater than 5 characters')
          .validate(val)
          .then(() => null)
          .catch(err => err.errors.join(', '))
      }
      {...props}
      data-cv-test-override={dataCvTest || 'addressZip'}
    />
  );
};

Zip.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

Zip.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': ''
};

export default Zip;
